import React, { useState, useEffect } from "react";
import { ChasingDots } from "better-react-spinkit";
import { number, func } from "prop-types";

const loadingPhrases = [
  "Processing your billing info, we'll move to payment shortly...",
  "Just a moment, we're getting your payment options ready...",
  "Finalizing your details, this will just take a few moments...",
  "Hang tight! We're processing your billing info, almost ready for payment...",
  "Reviewing your details, we'll have your payment ready in no time...",
  "We're almost done! Preparing your payment options...",
  "We’re finalizing everything now, payment is just a step away...",
  "Just a few more seconds, preparing your payment details now...",
  "Almost there! Your payment options will be available shortly...",
  "One more second! Your payment options are being prepared...",
];

// Request has it showing timeout error if wait time is over 30 seconds, but from UAT the wait time can be longer.
// Leaving it as 4 minutes for now until further notice
const LoadingPage = ({ timeout = 240000, setIsLoadingTimeOutInParent }) => {
  const [currentPhraseIndex, setCurrentPhraseIndex] = useState(0);
  const [loadingTimeout, setLoadingTimeout] = useState(false);

  // Rotate phrases every 3 seconds
  useEffect(() => {
    const phraseInterval = setInterval(() => {
      setCurrentPhraseIndex(
        (prevIndex) => (prevIndex + 1) % loadingPhrases.length
      );
    }, 3000);

    // Timeout for showing the error page after {timeout} seconds
    const timeoutId = setTimeout(() => {
      setLoadingTimeout(true);
    }, timeout);

    return () => {
      clearInterval(phraseInterval);
      clearTimeout(timeoutId);
    };
  }, [loadingPhrases.length, timeout]);

  // Handle timeout scenario
  useEffect(() => {
    if (loadingTimeout) {
      setIsLoadingTimeOutInParent();
    }
  }, [loadingTimeout]);

  return (
    <div className="page-wrapper loading-page-wrapper wide-gap">
      <div className="loading-animation">
        <ChasingDots color="#425CC7" size={72} />
      </div>
      <div className="loading-phrases">
        <p>{loadingPhrases[currentPhraseIndex]} </p>
        <p style={{ color: "#53565A" }}>
          This process may take up to 30 seconds. We appreciate your patience.
        </p>
      </div>
    </div>
  );
};

LoadingPage.propTypes = {
  timeout: number,
  setIsLoadingTimeOutInParent: func.isRequired,
};

export default LoadingPage;
